/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- NAV : STYLES --------------- ++++++++++ */
export default {
	startmigration: {
    display: 'flex',
    flexDirection: 'column',
    gap: pxToEm(16),
    '& path': {
      fill: '#000'
    },
    '& .button': {
      color: theme.color.primary.medium.contrast,
      background: theme.color.primary.medium.swatch
    },
    '& .migrationongoing': {
      display: 'flex',
      flexDirection: 'column',
      gap: pxToEm(8),
      '& p': {
        color: '#F88923',
        fontSize: pxToEm(12),
        textAlign: 'center'
      },
      '& .button': {
        color: '#DFDFDF !important',
      }
    }
  }
}; 